/* eslint-disable */
import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import BootstrapVue from 'bootstrap-vue';
import store from './store/store';
import { createRouter } from "./routers/router";
import App from './App.vue';

// eslint-disable-next-line
import VueAxios from './plugins/axios';

// Bootstrap styles
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

// Custom styles
import '@/assets/css/colors.scss';
import '@/assets/css/constants.scss';
import '@/assets/css/global.scss';
import '@/assets/css/overrides.scss';
import '@/assets/css/sidebar.scss';
import '@/assets/css/headerMenu.scss';
import '@/assets/css/embla-theme.scss'; // Embla(carousels) theme
import 'animate.css';
import './assets/css/hover.css';

// Utilities
import VueScrollTo from 'vue-scrollto';
import Notifications from 'vue-notification';
import _ from 'lodash';
import { AtomSpinner } from 'epic-spinners';

// i18n
import VueI18n from 'vue-i18n';
import dateTimeFormats from './i18n/date-time-formats';
import numberFormats from './i18n/number-formats';

Vue.use(VueI18n);

// get the translations from single files
const messages = {
  en: require('./i18n/locales/en.json'),
  es: require('./i18n/locales/es.json'),
};

const i18n = new VueI18n({
  // User navigator language
  // locale: navigator.language.split('-')[0],
  locale: 'es-MX', // By now will only work with mexican spanish
  fallbackLocale: 'es', // backup lenguage if the user language isnt found
  messages, // messages object
  dateTimeFormats,
  numberFormats,
  debug: process.env.DEBUG_MODE, // debug mode
});

Vue.use(Notifications);
Vue.use(AtomSpinner);

// You can also pass in the default options
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease-in-out',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});

library.add(fas, fab);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.use(BootstrapVue);

Vue.config.productionTip = false;

/* This function make a call to API (using vuex store) to get csrf token.
  If an error is catched here could mean BackEnd is dead. So depending on what happned,
  we will set true or false on vuex mutation "setBackendAvailable" */ 
async function setupVueApp() {
  try {
    // Get and setup the csrf token and the site status
    await store.dispatch('authStore/getCsrfTokenAndStatus');

    // Get and setup feature flags
    await store.dispatch('featureFlagStore/fetchInstanceFeatFlags');

    // Get the categories, otherwise UI wont render correctly
    await store.dispatch('categoryStore/getCategoriesData');

    // If every request was okay, set flags to permit navigation
    store.commit('backendStore/setBackendAvailable', true);
    store.commit('backendStore/setTooManyRequestsErr', false);
    return;
  } catch (error) {
    // If error has custom message 'http_error_429', server is alive but user banned
    if(error.message && error.message === 'http_error_429') {
      // Set error 429 as true
      store.commit('backendStore/setTooManyRequestsErr', true);
      return;
    }

    // If error wasn't a custom one, set backendAvailable as false
    store.commit('backendStore/setBackendAvailable', false);

    /* By setting in previous mutations, vue-router (after vue app is mounted)
    will block user navigation and will only display an error page */
    
    return;
  }
}

// This mount the vue app only after setupVueApp() has finished
setupVueApp()
  .then(() => {
    const router = createRouter();

    new Vue({
      router,
      store,
      i18n,
      render: h => h(App)
    }).$mount('#app');
  });
